/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type TrinityLogin_viewer$ref = any;
export type TrinityLogin_QueryVariables = {};
export type TrinityLogin_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": TrinityLogin_viewer$ref;
    }) | null;
};
export type TrinityLogin_Query = {
    readonly response: TrinityLogin_QueryResponse;
    readonly variables: TrinityLogin_QueryVariables;
};



/*
query TrinityLogin_Query {
  viewer {
    id
    ...TrinityLogin_viewer
  }
}

fragment TrinityLogin_viewer on Viewer {
  id
  user {
    id
    role
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "TrinityLogin_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "TrinityLogin_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "TrinityLogin_Query",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "role",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "TrinityLogin_Query",
            "id": null,
            "text": "query TrinityLogin_Query {\n  viewer {\n    id\n    ...TrinityLogin_viewer\n  }\n}\n\nfragment TrinityLogin_viewer on Viewer {\n  id\n  user {\n    id\n    role\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '58aca9ae2346b771eac9dd994ccc8e55';
export default node;
